module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#instagram",
      toString: function () {
        return this.url;
      }
    }